define('models/Account',[
	'core/can',
	'models/Base',
	'models/Credential'
], function(can, Base, Credential) {
	
	var Account = Base.extend({
		
		// Get Accounts this User is also tied to
		findAll: 'GET /Account/List',
		
		// Get Account currently signed into
		findOne: 'GET /Account/{id}',
		create: 'POST /Account',
		update: 'PUT /Account',
		// destroy: 'DELETE /Account/{id}',
		
		findChildren: function(params, success, error) {
			return can.ajax({
					type: 'GET',
					url: '/Account/Children',
					data: params
				})
				.then(can.proxy(this.models, this))
				.then(success, error);
		}
	
	},{
		define: {
			// Name
			// Number
			// AgencyId
			// ParentId
			Type: {
				type: 'number',
				set: function(val) {
					switch (val) {
						case 0: // None
						case 1: // Regular
						case 2: // Vendor
							return val;
						default:
							return 0;
					}
				}
			}
		}
	});
	
	Account.List = Account.List.extend({
		comparator: 'Name'
	});
	
	return Account;

});
